import deDE from './de-DE.json';
import enUS from './en-US.json';
import esES from './es-ES.json';
import frFR from './fr-FR.json';
import huHU from './hu-HU.json';
import itIT from './it-IT.json';
import nlNL from './nl-NL.json';
import roRO from './ro-RO.json';


interface Language {
  translation: { };
}

const translations: Record<string, Language> = {
  'en-US': enUS,
  'hu-HU': huHU,
  'ro-RO': roRO,
  'de-DE': deDE,
  'es-ES': esES,
  'fr-FR': frFR,
  'it-IT': itIT,
  'nl-NL': nlNL
};

export default translations;